import IndexApi from './index'
//按钮权限
let Authoritys = (IndexApi.userInfo && IndexApi.userInfo.userOptAuthority instanceof Array)?IndexApi.userInfo.userOptAuthority:[];
//菜单权限
let MenuAuthority = (IndexApi.RouterList && IndexApi.RouterList instanceof Array)?IndexApi.RouterList:[];
let keyApiUrl = {},menuApi={};
let adminsApi = {//用户与权限  系统设置
	
}
//后台部分接口未加权限，所以url直接写入方法中
getApiUrl(MenuAuthority,menuApi);//菜单接口
getApiUrl(Authoritys,keyApiUrl);//按键接口
function getApiUrl (arr,obj){
	arr.forEach((v)=>{
		if(v.authorityUrl){
			getStrUrl(v.authorityUrl,obj)
		}
		if(v.childAuthority && v.childAuthority instanceof Array){
			getApiUrl(v.childAuthority,obj);
		}		
	})
}
function getStrUrl (str,obj){
	let keys = str.split("/");
	let key = "";
	keys.forEach((v,i)=>{
		if(v){
			if(i!=keys.length-1){
				key+=v+"_"
			}else{
				key+=v;
			}				
		}
	});
	if(!obj[key]){
		obj[key] = str;
	}
}

console.log(keyApiUrl,menuApi)
export default {apis:{...keyApiUrl,...menuApi,...adminsApi},keysApi:keyApiUrl,menusApi:menuApi,adminsApi:adminsApi}



// WEBPACK FOOTER //
// ./src/public/api.js